export class PerformanceTimer {
    static start(id) {
        const startTime = this.timers.get(id);
        if (startTime !== undefined) {
            return;
        }
        this.timers.set(id, performance.now());
    }
    static stop(id) {
        const startTime = this.timers.get(id);
        if (startTime === undefined) {
            return 0;
        }
        const endTime = performance.now();
        const elapsed = endTime - startTime;
        if (elapsed > 10)
            console.error(`[PerformanceTimer] ${id}: ${elapsed.toFixed(3)} ms`);
        else
            console.log(`[PerformanceTimer] ${id}: ${elapsed.toFixed(3)} ms`);
        // cleanup for next loop
        this.timers.delete(id);
        return elapsed;
    }
}
PerformanceTimer.timers = new Map();
